import React from 'react';
// import PropTypes from 'prop-types';
import { css } from 'react-emotion';
// import ribbon from '../../static/img/ribbon.png';

// const chart = css({
//   backgroundColor: '#fff',
//   border: '1px solid #e6e6e6',
//   borderRadius: '5px!important',
//   boxShadow: '0 0 2px 0 rgba(181,181,181,.3)',
//   padding: '20px 40px',
//   textAlign: 'center',
//   width: '280px',
//   float: 'left',
//   minHeight: 315,
//   position: 'relative',
//   top: 20,
// });

const headerTitle = css({
  textAlign: 'left',
  borderRadius: '3px 3px 0 0',
  marginBottom: 30,
  padding: '23px 30px',
  fontSize: 18,
  height: 75,
  borderBottom: '1px solid #dfdfdf',
  fontWeight: 500,
  color: '#444',
  background: '#fbfbfb',
});

const planHeader = css({
  textAlign: 'center',
  background: '#fbfbfb',
  marginBottom: 30,
  fontWeight: 500,
  fontSize: 18,
  color: '#444',
  padding: '13px 0',
  borderBottom: '1px solid #dfdfdf',
});

const feature = css({
  marginBottom: 32,
  paddingLeft: 70,
  fontSize: 15,
  position: 'relative',
});

const price = css({
  color: '#1a80d9',
  position: 'relative',
  top: 3,
  fontSize: 14,
});

class PlanComparison extends React.Component {
  render() {
    return (
      <div
        className="chart clearfix d-flex align-items-stretch"
        style={{
          marginTop: 60,
          border: '1px solid #dfdfdf',
          borderRadius: 3,
          minWidth: 930,
        }}
      >
        <div className="features-col" style={{ width: '40%' }}>
          <div className={headerTitle}>Features</div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-laptop"
            />
            Throttled Internet
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-bar-chart"
            />
            Charts and Stuff
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-headphones"
            />
            Free Beats By Dr. Dre Headphones
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-wifi"
            />
            Unlimited Wifi
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-plane"
            />
            Unlimited Flights to Jordan
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-taxi"
            />
            3 Free Uber Rides
          </div>
          <div className={feature}>
            <i
              style={{
                position: 'absolute',
                fontSize: 21,
                color: '#8aa6cc',
                left: 23,
              }}
              className="fa fa-cutlery"
            />
            Catered Lunches
          </div>
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: '20%', borderLeft: '1px solid #dfdfdf' }}
        >
          <div className={planHeader}>
            Bite Size Plan
            <div className={price}>$15/mo</div>
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>

          <a
            href="/signup"
            className="btn-shadow btn-shadow-success align-self-center mt-auto"
            style={{
              border: 0,
              fontWeight: 600,
              color: '#fff',
              display: 'inline-block',
              boxShadow: 'rgba(23,43,99,.24) 0 7px 28px',
              textTransform: 'uppercase',
              letterSpacing: 1,
              fontSize: 13,
              padding: '12px 23px',
              textShadow: '1px 1px rgba(0,0,0,.09)',
              borderRadius: 4,
              cursor: 'pointer',
              textAlign: 'center',
              '-webkit-transition': 'all .2s',
              '-moz-transition': 'all .2s',
              '-ms-transition': 'all .2s',
              '-o-transition': 'all .2s',
              transition: 'all .2s',
              marginBottom: 20,
              background: '#3498db',
            }}
          >
            Sign up free
          </a>
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: '20%', borderLeft: '1px solid #dfdfdf' }}
        >
          <div className={planHeader}>
            Smedium Plan
            <div className={price}>$5,000/mo</div>
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>

          <a
            href="/signup"
            className="btn-shadow btn-shadow-success align-self-center mt-auto"
            style={{
              border: 0,
              fontWeight: 600,
              color: '#fff',
              display: 'inline-block',
              boxShadow: 'rgba(23,43,99,.24) 0 7px 28px',
              textTransform: 'uppercase',
              letterSpacing: 1,
              fontSize: 13,
              padding: '12px 23px',
              textShadow: '1px 1px rgba(0,0,0,.09)',
              borderRadius: 4,
              cursor: 'pointer',
              textAlign: 'center',
              '-webkit-transition': 'all .2s',
              '-moz-transition': 'all .2s',
              '-ms-transition': 'all .2s',
              '-o-transition': 'all .2s',
              transition: 'all .2s',
              marginBottom: 20,
              background: '#3498db',
            }}
          >
            Sign up free
          </a>
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: '20%', borderLeft: '1px solid #dfdfdf' }}
        >
          <div className={planHeader}>
            Big Boy Plan
            <div className={price}>$10,000/mo</div>
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>
          <div className={feature} style={{ marginBottom: '3rem!important' }}>
            <div
              style={{
                color: '#1a80d9',
                margin: '0 auto',
                display: 'inline-block',
                maxWidth: 20,
                verticalAlign: 'bottom',
                borderStyle: 'none',
                textAlign: 'center',
                marginLeft: 30,
              }}
              className="fa fa-check fa-lg"
              aria-hidden="true"
            />
          </div>

          <a
            href="/signup"
            className="btn-shadow btn-shadow-success align-self-center mt-auto"
            style={{
              border: 0,
              fontWeight: 600,
              color: '#fff',
              display: 'inline-block',
              boxShadow: 'rgba(23,43,99,.24) 0 7px 28px',
              textTransform: 'uppercase',
              letterSpacing: 1,
              fontSize: 13,
              padding: '12px 23px',
              textShadow: '1px 1px rgba(0,0,0,.09)',
              borderRadius: 4,
              cursor: 'pointer',
              textAlign: 'center',
              '-webkit-transition': 'all .2s',
              '-moz-transition': 'all .2s',
              '-ms-transition': 'all .2s',
              '-o-transition': 'all .2s',
              transition: 'all .2s',
              marginBottom: 20,
              background: '#3498db',
            }}
          >
            Sign up free
          </a>
        </div>
      </div>
    );
  }
}

export default PlanComparison;



// WEBPACK FOOTER //
// ./src/views/public/Pricing/PlanComparison.js